import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = () => (
  <section className="relative overflow-hidden bg-card pt-24 lg:pt-28" data-testid="hero-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 pb-14 pt-8 lg:grid-cols-12 lg:gap-8 lg:px-10 lg:pb-20 lg:pt-12">
      {/* Text block */}
      <div className="flex flex-col justify-center lg:col-span-5 lg:pr-6">
        <p className="fade-up text-xs font-semibold uppercase tracking-[0.22em] text-accent">
          Rekonstrukce a fasády · Plzeň a okolí
        </p>
        <h1 className="fade-up delay-100 mt-5 text-4xl font-semibold leading-[1.12] tracking-tight text-foreground sm:text-5xl lg:text-[56px]">
          Rekonstrukce bytů, domů a fasád{" "}
          <span className="font-serif-accent font-medium italic text-primary">
            v Plzni a okolí.
          </span>
        </h1>
        <p className="fade-up delay-200 mt-6 max-w-md text-base leading-relaxed text-muted-foreground">
          Kvalitní stavební práce za férovou cenu. Dodržujeme termíny,
          pracujeme pečlivě a nabízíme nezávaznou cenovou nabídku zdarma.
        </p>
        <div className="fade-up delay-300 mt-8 flex flex-col gap-3 sm:flex-row">
          <Button asChild data-testid="hero-cta-primary" className="h-12 bg-primary px-7 text-primary-foreground hover:bg-primary/90">
            <Link to="/#kontakt">
              Získat nezávaznou nabídku
              <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            data-testid="hero-cta-secondary"
            className="h-12 border-foreground/25 bg-transparent px-7 text-foreground hover:bg-foreground/5 hover:text-foreground"
          >
            <Link to="/#realizace">Prohlédnout realizace</Link>
          </Button>
        </div>
        <p className="fade-up delay-400 mt-7 flex items-center gap-2 text-sm text-muted-foreground">
          <MessageCircle className="h-4 w-4 text-accent" />
          Přímá komunikace s majitelem firmy
        </p>
      </div>

      {/* Photo composition — real Goalstav projects */}
      <div className="relative lg:col-span-7">
        <div className="grid grid-cols-12 gap-4">
          <figure className="img-reveal col-span-12 sm:col-span-8">
            <img
              src="./images/hero-cinzovni-dum.webp"
              alt="Dokončená fasáda činžovního domu v Plzni"
              className="h-[300px] w-full rounded-md object-cover sm:h-[440px] lg:h-[520px]"
              fetchPriority="high"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">
              Fasáda činžovního domu · Plzeň
            </figcaption>
          </figure>
          <figure className="img-reveal-delayed col-span-12 hidden sm:col-span-4 sm:block sm:self-end">
            <img
              src="./images/rekonstrukce-schodiste.jpg"
              alt="Nové schodiště s dřevěným obkladem po rekonstrukci"
              className="h-[300px] w-full rounded-md object-cover lg:h-[360px]"
              loading="lazy"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">
              Rekonstrukce interiéru
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </section>
);
